<template>
  <div>
    <h1 class="template-name">Hello, {{ $store.getters.user.data.displayName }}.</h1>
    <p>What #StuffToDo category that you want to check?</p>
    <hr>
    <div>
      <b-row>
        <b-col cols="12" md="6" class="card-container">
          <list-category-card icon="inbox"
                              list-category-name="Inbox"
                              list-category-description="A quick list for any occasions."></list-category-card>
        </b-col>
        <b-col cols="12" md="6" class="card-container">
          <list-category-card icon="exclamation"
                              list-category-name="Important"
                              list-category-description="Jump to your most important tasks."></list-category-card>
        </b-col>
      </b-row>
    </div>

    <div>
      <b-row>
        <b-col cols="12" md="6" class="card-container">
          <list-category-card icon="sun"
                              list-category-name="Today"
                              list-category-description="Take a look at your tasks for today."></list-category-card>
        </b-col>
        <b-col cols="12" md="6" class="card-container">
          <list-category-card icon="id-card"
                              list-category-name="Assigned"
                              list-category-description="Access tasks assigned to you."></list-category-card>
        </b-col>
      </b-row>
    </div>

    <div>
      <b-row>
        <b-col cols="12" md="6" class="card-container">
          <list-category-card icon="calendar-day" list-category-name="Planned"
                              list-category-description="Planned tasks. No surprise."></list-category-card>
        </b-col>
        <b-col cols="12" md="6" class="card-container">
          <list-category-card icon="clock" list-category-name="Overdue"
                              list-category-description="It is never too late to finish the tasks."></list-category-card>
        </b-col>
      </b-row>
    </div>

    <div>
      <b-row>
        <b-col cols="12" md="6" class="card-container">
          <list-category-card icon="user" list-category-name="Personal List"
                              list-category-description="Your personally tailored list, just for you."></list-category-card>
        </b-col>
        <b-col cols="12" md="6" class="card-container">
          <list-category-card icon="user-friends" list-category-name="Collaborative List"
                              list-category-description="Collaborate together to achieve the goals."></list-category-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import ListCategoryCard from "../home_card/ListTemplateCard"
  import {mapGetters} from "vuex";

  export default {
    name: "ListCategoryHome.vue",
    components: {
      listCategoryCard: ListCategoryCard
    },
  }
</script>

<style scoped>
  .card-container {
    margin-bottom: 1em;
  }
</style>
